import React from 'react';

const Logo = ({ size = 120 }) => {
  const cx = size / 2;
  const cy = size / 2;
  const outerR = (size / 2) - 4;
  const innerR = (size / 2) - 14;
  const textR = (size / 2) - 9;
  const fontSize = size * 0.085;
  const iconSize = size * 0.28;

  // Calculate text path for the arc
  const circumference = 2 * Math.PI * textR;

  return (
    <svg
      width={size}
      height={size}
      viewBox={`0 0 ${size} ${size}`}
      xmlns="http://www.w3.org/2000/svg"
      style={{ display: 'block' }}
    >
      <defs>
        <linearGradient id="logoGrad" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="#FF6B35" />
          <stop offset="100%" stopColor="#FF8C42" />
        </linearGradient>
        <linearGradient id="bgGrad" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="#FFF8F0" />
          <stop offset="100%" stopColor="#FFE8DC" />
        </linearGradient>
        <path
          id="topArc"
          d={`M ${cx - textR},${cy} A ${textR},${textR} 0 0,1 ${cx + textR},${cy}`}
        />
        <path
          id="bottomArc"
          d={`M ${cx - textR},${cy} A ${textR},${textR} 0 0,0 ${cx + textR},${cy}`}
        />
      </defs>

      {/* Outer circle border */}
      <circle cx={cx} cy={cy} r={outerR} fill="url(#logoGrad)" />

      {/* Inner white/cream fill */}
      <circle cx={cx} cy={cy} r={innerR} fill="url(#bgGrad)" />

      {/* Decorative dots on border */}
      {[0, 45, 90, 135, 180, 225, 270, 315].map((angle, i) => {
        const rad = (angle * Math.PI) / 180;
        const dotR = outerR - 3;
        const x = cx + dotR * Math.cos(rad);
        const y = cy + dotR * Math.sin(rad);
        return <circle key={i} cx={x} cy={y} r={size * 0.018} fill="white" opacity="0.7" />;
      })}

      {/* Lotus / Hands icon - simplified using paths */}
      {/* Two hands forming a circle (namaste/unity symbol) */}
      <g transform={`translate(${cx - iconSize / 2}, ${cy - iconSize * 0.7})`}>
        {/* Left person */}
        <ellipse cx={iconSize * 0.28} cy={iconSize * 0.22} rx={iconSize * 0.11} ry={iconSize * 0.11} fill="#FF6B35" />
        <rect x={iconSize * 0.17} y={iconSize * 0.33} width={iconSize * 0.22} height={iconSize * 0.32} rx={iconSize * 0.06} fill="#FF6B35" />

        {/* Right person */}
        <ellipse cx={iconSize * 0.72} cy={iconSize * 0.22} rx={iconSize * 0.11} ry={iconSize * 0.11} fill="#4CAF50" />
        <rect x={iconSize * 0.61} y={iconSize * 0.33} width={iconSize * 0.22} height={iconSize * 0.32} rx={iconSize * 0.06} fill="#4CAF50" />

        {/* Joining hands / heart between */}
        <path
          d={`M ${iconSize * 0.39} ${iconSize * 0.42}
              C ${iconSize * 0.39} ${iconSize * 0.35} ${iconSize * 0.50} ${iconSize * 0.30} ${iconSize * 0.50} ${iconSize * 0.37}
              C ${iconSize * 0.50} ${iconSize * 0.30} ${iconSize * 0.61} ${iconSize * 0.35} ${iconSize * 0.61} ${iconSize * 0.42}
              C ${iconSize * 0.61} ${iconSize * 0.52} ${iconSize * 0.50} ${iconSize * 0.58} ${iconSize * 0.50} ${iconSize * 0.58}
              C ${iconSize * 0.50} ${iconSize * 0.58} ${iconSize * 0.39} ${iconSize * 0.52} ${iconSize * 0.39} ${iconSize * 0.42}`}
          fill="#FF6B35"
        />
      </g>

      {/* "SaathiCircle" text along top arc */}
      <text fontSize={fontSize} fontFamily="'Hind', 'Poppins', sans-serif" fontWeight="700" fill="#FF6B35" letterSpacing="0.5">
        <textPath href="#topArc" startOffset="50%" textAnchor="middle">
          SaathiCircle
        </textPath>
      </text>

      {/* "Senior Community" text along bottom arc */}
      <text fontSize={fontSize * 0.85} fontFamily="'Hind', 'Poppins', sans-serif" fontWeight="500" fill="#666" letterSpacing="0.3">
        <textPath href="#bottomArc" startOffset="50%" textAnchor="middle">
          Senior Community
        </textPath>
      </text>
    </svg>
  );
};

export default Logo;
